import { initializeYup, InquiryKind, isEmpty } from "@duosoftbg/nacid-components";
import * as yup from "yup";
import { YEAR_VALIDATION_REGEX } from "../utils/regexExpressions";
import i18n from "i18next";

export const createInquiryDetailsValidationSchema = () => {
  initializeYup(yup);

  const inquiryDetailsValidationSchema = yup.object({
    inquiryKinds: yup.array().min(1),
    periodFrom: yup.string().required().matches(YEAR_VALIDATION_REGEX),
    periodTo: yup
      .string()
      .required()
      .matches(YEAR_VALIDATION_REGEX)
      .test("from-before-to", i18n.t("validation.from.before.to"), function () {
        const { periodFrom, periodTo } = this.parent;

        if (!periodFrom || !periodTo) return true;

        return parseInt(periodFrom) <= parseInt(periodTo);
      }),
    previousInquiryNum: yup
      .string()
      .nullable(true)
      .test("required", i18n.t("validation.previousInquiryNum.or.CITINGS"), function (value) {
        const kinds: InquiryKind[] = this.parent?.inquiryKinds ?? [];
        const hasCitingsFromMultiple = this.options.context?.appsFromMultiple?.some(
          (app) => app.inquiryKind === InquiryKind.IMPACT_FACTOR_CITINGS,
        );

        const requiresValue =
          kinds.includes(InquiryKind.IMPACT_FACTOR_CITINGS) &&
          !kinds.includes(InquiryKind.CITINGS) &&
          !hasCitingsFromMultiple;

        if (requiresValue) {
          return !!value;
        }

        return true;
      }),
    citingSearchKind: yup.object().shape({
      id: yup
        .string()
        .nullable(true)
        .test("required", i18n.t("validation.field.required"), function (_value) {
          const kinds: InquiryKind[] = this?.options?.context?.inquiryKinds ?? [];
          const requiresValue = kinds.includes(InquiryKind.CITINGS);

          if (requiresValue && isEmpty(_value)) {
            return this.createError({
              path: this.path,
              message: i18n.t("validation.field.required"),
            });
          }
          return true;
        }),
    }),
    impactFactorSearchKind: yup.object().shape({
      id: yup.string().test("required", i18n.t("validation.field.required"), function (_value) {
        const kinds: InquiryKind[] = this?.options?.context?.inquiryKinds ?? [];
        const requiresValue =
          kinds.includes(InquiryKind.IMPACT_FACTOR) || kinds.includes(InquiryKind.IMPACT_FACTOR_CITINGS);

        if (requiresValue && isEmpty(_value)) {
          return this.createError({
            path: this.path,
            message: i18n.t("validation.field.required"),
          });
        }
        return true;
      }),
    }),
  });

  return inquiryDetailsValidationSchema;
};
